

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'ui-textarea',
})
export default class UiTextAreaComponent extends Vue {
  @Prop({ default: 5, type: Number })
  height: Number;
  @Prop({ default: 'none', type: String })
  resize: String;
  @Prop({ default: '' })
  label!: string;
  @Prop({ default: false })
  required!: boolean;
  @Prop({ default: false })
  readonly!: boolean;
  @Prop({ default: '' })
  placeholder!: string;
  @Prop({ default: '' })
  value!: string;
  @Prop({ default: '5' })
  row!: string;
  @Prop({ default: false })
  autofocus: boolean;
  @Prop({ default: false })
  transformer!: boolean;
  @Prop({ default: false })
  error!: boolean;
  @Prop()
  minLength: number;

  @Prop({ default: 'dark', type: String })
  theme: string;

  focused = false;
  innerValue = this.value;
  hasError: boolean = false;
  errorMessage: string = '';

  @Watch('focused')
  onChangeFocus() {
    this.$emit('focus', this.focused);
  }
  @Watch('autofocus')
  getAutofocus() {
    return this.autofocus;
  }
  @Watch('innerValue')
  onInnerValueChanged(newValue: string) {
    this.isValid();
    if (this.innerValue !== this.value) {
      this.$emit('input', this.innerValue);
    }
  }
  @Watch('value')
  onValueChanged(newValue: string) {
    if (this.innerValue !== this.value) {
      this.innerValue = this.value;
    }
  }

  isValid(): boolean {
    this.errorMessage = '';
    if (this.required && !this.innerValue) {
      this.errorMessage = '*Поле обязательно';
      this.hasError = true;
      return false;
    }
    if (this.minLength && this.innerValue.length < this.minLength) {
      this.errorMessage = `*Минимум ${this.minLength} символов`;
      this.hasError = true;
      return false;
    }
    this.hasError = false;
    return true;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-textarea/src/ui-textarea.vue